import { formatDateTime } from "@/common/dateUtils";
import {
  toggleDeepInsightArchive,
  toggleDeepInsightPin,
} from "@/lib/serverComm.tsx";
import {
  Archive,
  ArchiveRestore,
  ArrowRight,
  LoaderCircle,
  Pin,
} from "lucide-react";
import React, { JSX, useState } from "react";
import { Link } from "react-router-dom";

interface InsightCardProps {
  id: string;
  chip?: string;
  category: string;
  title: string;
  description: string;
  date: string;
  isPinned: boolean;
  isArchived: boolean;
  reload: () => void;
}

const InsightCard: React.FC<InsightCardProps> = ({
  id,
  chip,
  category,
  title,
  description,
  date,
  isPinned,
  isArchived,
  reload,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  console.log("isArchived", isArchived);

  const togglePin = async () => {
    setIsLoading(true);
    await toggleDeepInsightPin(id);
    setIsLoading(false);
    reload();
  };

  const toggleArchive = async () => {
    setIsLoading(true);
    await toggleDeepInsightArchive(id);
    setIsLoading(false);
    reload();
  };

  const pinIcon = (): JSX.Element => {
    if (isLoading) {
      return <LoaderCircle size={22} className="text-sky-500 cursor-pointer" />;
    }

    if (isPinned) {
      return (
        <Pin
          size={22}
          strokeWidth={3.5}
          className="text-sky-600 cursor-pointer"
          onClick={togglePin}
        />
      );
    }

    return (
      <Pin
        size={22}
        className="text-sky-500 cursor-pointer"
        onClick={togglePin}
      />
    );
  };

  const archiveIcon = (): JSX.Element => {
    if (isLoading) {
      return <LoaderCircle size={22} className="text-sky-500 cursor-pointer" />;
    }

    if (isArchived) {
      return (
        <ArchiveRestore
          size={22}
          className="text-sky-500 cursor-pointer"
          onClick={toggleArchive}
        />
      );
    }

    return (
      <Archive
        size={22}
        className="text-sky-500 cursor-pointer"
        onClick={toggleArchive}
      />
    );
  };

  return (
    <div className="border rounded-lg border-gray-300 bg-white p-7 flex flex-col flex-1">
      <div className="flex items-center mb-5">
        {chip !== undefined && chip.length > 0 && (
          <div className="rounded-full bg-sky-500 text-white text-xs pt-1 pb-1 pr-4 pl-4 mr-5">
            {chip}
          </div>
        )}
        <div className="text-xs text-sky-500 flex-1">{category}</div>
        <div className="flex items-center gap-3">
          {pinIcon()}
          {archiveIcon()}
        </div>
      </div>

      <h3 className="text-base font-bold mb-4">{title}</h3>

      <p className="text-sm mb-4 flex-1">{description}</p>

      <div className="flex items-center justify-between">
        <div className="text-xs text-gray-500">
          {formatDateTime(new Date(date))}
        </div>
        <div>
          <Link to={`/deep-insights/${id}`}>
            <ArrowRight
              size={22}
              className="rounded-full bg-sky-500 text-white p-1"
            />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default InsightCard;
